import { setWebRTCError, resetWebRTCError,setWebRTCSession, resetWebRTCSession, setCCPState, updateMediaDevicesAction, updateMediaDeviceAction, updateSpeakerDeviceAction, updateMicrophoneDeviceAction, updateVoiceNewtworkState, setCurrentCcpInstanceAction } from '../actions/webrtc';
import {
    CCP_STATE,
    CCP_INSTANCE,
    STATE_UPDATE_RING_MEDIA_DEVICE
} from '../constants/constants';
import { 
    UPDATE_MEDIA_DEVICES_LIST,
    STATE_UPDATE_SPEAKER_DEVICE,
    STATE_UPDATE_MICROPHONE_DEVICE
} from '../constants/events';
import Emitter from '../emitter';
// import Emitter from '../emitter';
import store from '../store';
import storeRTK from '../store/storeRTK';

/**
 * Handling the call state update functonality
 * @param {*} message
 */
export function setError(message:any) {
    store.dispatch(setWebRTCError(message.body?.reason));
}
export function resetError() {
    store.dispatch(resetWebRTCError());
}
export function webRTCSetSession(message:any) {
    store.dispatch(setWebRTCSession(message.body?.session));
}
export function webRTCResetSession() {
    store.dispatch(resetWebRTCSession());
}
export function updateCcpState(message:any) {
    storeRTK.dispatch(setCCPState(message?.status));
}
export function updateMediaDevices(message: any) {
  const mediaDevices = message.body?.mediaDevices;
  storeRTK.dispatch(updateMediaDevicesAction(mediaDevices));

  if (!mediaDevices || !Array.isArray(mediaDevices)) {
    return;
  }

  const { speakerDeviceId, microphoneDeviceId, ringtoneOutoutDeviceId } =
    storeRTK.getState().webrtc;

  // Check if default devices exist
  const hasDefaultOutput = mediaDevices.some(
    (device: any) =>
      device.kind === "audiooutput" && device.deviceId === "default"
  );
  const hasDefaultInput = mediaDevices.some(
    (device: any) =>
      device.kind === "audioinput" && device.deviceId === "default"
  );

  // Helper to check if device still exists in the current device list
  const deviceExists = (deviceId: string, kind: string) =>
    mediaDevices.some(
      (device: any) => device.deviceId === deviceId && device.kind === kind
    );

  // Set to "default" if undefined OR if previously selected device no longer exists
  if ((!speakerDeviceId || !deviceExists(speakerDeviceId, "audiooutput")) && hasDefaultOutput) {
    storeRTK.dispatch(updateSpeakerDeviceAction("default"));
  }

  if ((!microphoneDeviceId || !deviceExists(microphoneDeviceId, "audioinput")) && hasDefaultInput) {
    storeRTK.dispatch(updateMicrophoneDeviceAction("default"));
  }

  if ((!ringtoneOutoutDeviceId || !deviceExists(ringtoneOutoutDeviceId, "audiooutput")) && hasDefaultOutput) {
    storeRTK.dispatch(updateMediaDeviceAction("default"));
  }
}

export function updateSelectedMediaDevice(message:any) {
    if(message.success) {
        storeRTK.dispatch(updateMediaDeviceAction(message.body?.deviceId));
    } else {
        console.log("Error in updating selected Media Device", message.body.error);
    }
}

export function updateSelectedSpeakerDevice(message:any) {
    if(message.success) {
        storeRTK.dispatch(updateSpeakerDeviceAction(message.body?.deviceId));
    } else {
        console.log("Error in updating selected Speaker Device", message.body?.error);
    }
}

export function updateSelectedMicrophoneDevice(message:any) {
    if(message.success) {
        storeRTK.dispatch(updateMicrophoneDeviceAction(message.body?.deviceId));
    } else {
        console.log("Error in updating selected Microphone Device", message.body?.error);
    }
}

export function setVoiceNewtworkState(message:any) {
    storeRTK.dispatch(updateVoiceNewtworkState(message.body?.isVoiceNetworkAvailable));
}

export function setCurrentCcpInstance(message:any) {
    storeRTK.dispatch(setCurrentCcpInstanceAction(message?.body?.currentCcpInstance));
}

/**
 * Register default Events for Call
 */
export default function registerWebRTCHandlerEvents() {
    // Emitter.on(WEBRTC_ERROR, setError);
    // Emitter.on(RESET_WEBRTC_ERROR, resetError);
    // Emitter.on(WEBRTC_SET_SESSION, webRTCSetSession);
    // Emitter.on(WEBRTC_RESET_SESSION, webRTCResetSession);
    Emitter.on(CCP_STATE, updateCcpState);
    Emitter.on(CCP_INSTANCE, setCurrentCcpInstance);
    Emitter.on(UPDATE_MEDIA_DEVICES_LIST, updateMediaDevices);
    Emitter.on(STATE_UPDATE_RING_MEDIA_DEVICE, updateSelectedMediaDevice);
    Emitter.on(STATE_UPDATE_SPEAKER_DEVICE, updateSelectedSpeakerDevice);
    Emitter.on(STATE_UPDATE_MICROPHONE_DEVICE, updateSelectedMicrophoneDevice);
    // Emitter.on(VOICE_NETWORK_STATE, setVoiceNewtworkState);
}
